import React from "react";
import Button from "@material-ui/core/Button";
import { useDispatch } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { NEInputLight as NEInput } from "../../../components/NEInput";
import request from "../../../shared/lib/request";
import { openSnackBar } from "../../Root/actions";
import {
  fetchTicketTypesById,
  setCustomerSupportLoader,
  getTicketTypesList,
} from "../actions";

export default function EditTicketTypeForm({
  formDetail,
  classes,
  toggleFn,
  id,
}: any) {
  const dispatch = useDispatch();
  const [error, setError] = React.useState({
    title: "",
    emailID: "",
  });

  const [state, setState] = React.useState({
    id: "",
    title: "",
    emailID: "",
    titleError: "",
    isTitleError: false,
    isConfirmDialogOpen: false,
    isConfirmPublishOpen: false,
  });

  React.useEffect(() => {
    if (formDetail) {
      setState((prevState) => ({
        ...prevState,
        id: formDetail.id,
        title: formDetail.title,
        emailID: formDetail.emailID,
      }));
    }
  }, [formDetail]);

  React.useEffect(() => {
    if (id) {
      dispatch(fetchTicketTypesById(id));
    }
  }, [id]);

  const handleChange = (event: any) => {
    if (!event.target.value) {
      setState({
        ...state,
        title: event.target.value,
        isTitleError: true,
        titleError: "Title is required",
      });
    } else {
      setState({
        ...state,
        title: event.target.value,
        isTitleError: false,
        titleError: "",
      });
    }
  };

  const handleChange1 = (event: any) => {
    setState({ ...state, emailID: event.target.value });
  };

  const onHandleSubmit = () => {
    let e = { title: "", emailID: "" };
    setError(e);

    const updateData = {
      id: state.id,
      title: state.title,
      emailID: state.emailID,
    };

    if (!state.title) {
      e.title = "Title is required";
      setError(e);
    } else if (!state.emailID) {
      e.emailID = "Email ID is required";
      setError(e);
    } else {
      saveTicketType(updateData);
    }
  };

  const saveTicketType = async (data: any) => {
    try {
      dispatch(setCustomerSupportLoader(true));

      await request({
        url: `/admin/v1/edit-ticket-type?id=${id}`,
        method: "PUT",
        data,
      });

      dispatch(setCustomerSupportLoader(false));
      toggleFn();
      dispatch(getTicketTypesList());
      dispatch(openSnackBar("The ticket type has been updated successfully!"));
    } catch (error: any) {
      dispatch(setCustomerSupportLoader(false));
      dispatch(openSnackBar((error && error.data && (error.data.error || error.data.message)) || 'Error updating data'));
    }
  };

  return (
    <React.Fragment>
      <div className={classes.titleWrapper}>
        <NEInput
          id="title"
          name="title"
          label="TITLE"
          value={state.title || ""}
          onChange={(e: any) => handleChange(e)}
          fullWidth
          variant="outlined"
          error={!!error.title}
          helperText={error.title}
          required
        />
      </div>
      <div className={classes.secondRow}>
        <NEInput
          id="emailID"
          name="emailID"
          label="EMAIL"
          value={state.emailID || ""}
          onChange={(e: any) => handleChange1(e)}
          fullWidth
          variant="outlined"
          error={!!error.emailID}
          helperText={error.emailID}
          required
        />
      </div>
      <Grid>
        <div className={classes.btnContainer}>
          <Button
            onClick={() => onHandleSubmit()}
            className={classes.newbtn}
            disableRipple
          >
            <div className={classes.saveLegalBtn}>SAVE</div>
          </Button>
        </div>
      </Grid>
    </React.Fragment>
  );
}
